import OrderState from '~/constants/orderState';
import { useUserPurchasing } from '~/context/vdp/UserVehicleContext';
import useIsReservableVehicle from './useIsReservableVehicle';

export default function useHasCorePurchaseAndIsViewingReservable() {
  const purchasing = useUserPurchasing();
  const isReservable = useIsReservableVehicle();

  return (
    Boolean(purchasing) &&
    purchasing?.orderState !== OrderState.Reserved &&
    isReservable
  );
}
